export const oidcSettings = {
  authority:
    (process.env.VUE_APP_HEROKU_API_BASE_URL || process.env.VUE_APP_APIPATH) +
    'oidc/',
  clientId: 'one-shop',
  redirect_uri:
    process.env.VUE_APP_HEROKU_OIDC_CALLBACK_URI ||
    process.env.VUE_APP_OIDC_CALLBACK_URI,
  responseType: 'code',
  scope: 'openid groups',
  post_logout_redirect_uri:
    process.env.VUE_APP_HEROKU_OIDC_LOGOUT_URI ||
    process.env.VUE_APP_OIDC_LOGOUT_URI,
  automaticSilentRenew: true,
  silent_redirect_uri:
    process.env.VUE_APP_HEROKU_OIDC_SILENT_RENEW_URI ||
    process.env.VUE_APP_OIDC_SRENEW_URI,
  accessTokenExpiringNotificationTime: 10,
  state: ''
}
